module.exports = __webpack_public_path__ + "static/media/readability-of-stories.cc77985f.pdf";